export default "__VITE_ASSET__erXZ2d5D__"